import 'preline'  // <--- CHANGED FROM 'preline/preline'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'aos/dist/aos.css'
import 'glightbox/dist/css/glightbox.min.css'
import '@/assets/css/icons.css'
import '@/assets/css/style.css'
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
// import VueApexCharts from "vue3-apexcharts";
import { useContextStore } from '@/stores/context'

import AOS from 'aos'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

// Initialize AOS
AOS.init()

const app = createApp(App)

const pinia = createPinia()
try {
  // sanity check that storage is actually usable before trusting it
  const testKey = '__storage_test__'
  localStorage.setItem(testKey, '1')
  localStorage.removeItem(testKey)
  pinia.use(piniaPluginPersistedstate)
} catch (e) {
  console.warn('[Pinia] localStorage unavailable, persistence disabled for this session', e)
   // No persistence plugin means afterHydrate will never fire, so the
   // isHydrated flag would hang forever in the router guard. Set it
   // manually here so navigation isn't blocked.
   const contextStore = useContextStore(pinia)
   contextStore.isHydrated = true
}

app.use(pinia)
app.use(router)
app.use(FloatingVue);
// app.use(VueApexCharts);

app.mount('#app')